export default __webpack_public_path__ + "static/media/yelp-logo.6adef24a.png";